/**
 * Maps icon string names (used in cornerstones/nl.js) → lucide-react components.
 * Keep in sync with icons referenced in /src/data/cornerstones/nl.js.
 */
import {
  Activity,
  Apple,
  ArrowRight,
  Award,
  Baby,
  Bell,
  BookOpen,
  Building2,
  Calendar,
  Check,
  ClipboardList,
  Compass,
  CreditCard,
  FileText,
  Heart,
  MessageSquare,
  Share2,
  Sparkles,
  Target,
  TrendingUp,
  Users,
  Video,
  X,
} from "lucide-react";

export const ICON_MAP = {
  Activity,
  Apple,
  ArrowRight,
  Award,
  Baby,
  Bell,
  BookOpen,
  Building2,
  Calendar,
  Check,
  ClipboardList,
  Compass,
  CreditCard,
  FileText,
  Heart,
  MessageSquare,
  Share2,
  Sparkles,
  Target,
  TrendingUp,
  Users,
  Video,
  X,
};

/** Resolve an icon name (string) → component. Falls back to a safe default. */
export function resolveIcon(name) {
  return ICON_MAP[name] || Sparkles;
}

export default ICON_MAP;
